/**
 * My API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpClient, HttpHeaders, HttpParams, HttpParameterCodec, HttpContext } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CustomHttpParameterCodec } from './encoder';
import { Configuration } from './configuration';

export type RequestOptions<Accept extends string | undefined = string | undefined> = {
  httpHeaderAccept?: Accept;
  context?: HttpContext;
  transferCache?: boolean;
};

/** The `observe`, `reportProgress` and `options` arguments every operation takes after its request parameters. */
export type RequestArgs = [observe?: any, reportProgress?: boolean, options?: RequestOptions];

export interface ApiRequest {
  method: string;
  /** Path relative to the configured base path, with path parameters already encoded. */
  path: string;
  /** Media types for the Accept header, used when the caller passes no `httpHeaderAccept`. */
  accepts: string[];
  /** Query parameters by name, in spec order; arrays and sets append one entry per element. */
  query?: Record<string, unknown>;
  headers?: Record<string, unknown>;
  body?: unknown;
  /** Media types for the Content-Type header; only set for operations with a body parameter. */
  consumes?: string[];
  responseFile?: boolean;
}

export class BaseService {
  protected basePath = 'http://localhost';
  public defaultHeaders = new HttpHeaders();
  public configuration: Configuration;
  public encoder: HttpParameterCodec;

  constructor(
    protected httpClient: HttpClient,
    basePath?: string | string[],
    configuration?: Configuration
  ) {
    this.configuration = configuration || new Configuration();
    if (typeof this.configuration.basePath !== 'string') {
      const firstBasePath = Array.isArray(basePath) ? basePath[0] : undefined;
      if (firstBasePath != undefined) {
        basePath = firstBasePath;
      }

      if (typeof basePath !== 'string') {
        basePath = this.basePath;
      }
      this.configuration.basePath = basePath;
    }
    this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
  }

  protected checkRequired(operation: string, params: Record<string, unknown>): void {
    for (const [name, value] of Object.entries(params)) {
      if (value === null || value === undefined) {
        throw new Error(`Required parameter ${name} was null or undefined when calling ${operation}.`);
      }
    }
  }

  protected sendRequest(
    [observe = 'body', reportProgress = false, options]: RequestArgs,
    request: ApiRequest
  ): Observable<any> {
    let localVarQueryParameters: HttpParams | undefined;
    if (request.query) {
      let params = new HttpParams({ encoder: this.encoder });
      for (const [key, value] of Object.entries(request.query)) {
        if (Array.isArray(value) || value instanceof Set) {
          value.forEach((element: unknown) => {
            params = this.addToHttpParams(params, <any>element, key);
          });
        } else if (value !== undefined && value !== null) {
          params = this.addToHttpParams(params, <any>value, key);
        }
      }
      localVarQueryParameters = params;
    }

    let localVarHeaders = this.defaultHeaders;
    for (const [name, value] of Object.entries(request.headers ?? {})) {
      if (value !== undefined && value !== null) {
        localVarHeaders = localVarHeaders.set(name, String(value));
      }
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(request.accepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    if (request.consumes) {
      const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(request.consumes);
      if (httpContentTypeSelected !== undefined) {
        localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
      }
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (request.responseFile) {
      responseType_ = 'blob';
    } else if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    return this.httpClient.request(request.method, `${this.configuration.basePath}${request.path}`, {
      context: localVarHttpContext,
      body: request.body,
      ...(localVarQueryParameters && { params: localVarQueryParameters }),
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  protected canConsumeForm(consumes: string[]): boolean {
    return consumes.indexOf('multipart/form-data') !== -1;
  }

  protected addToHttpParams(httpParams: HttpParams, value: any, key?: string): HttpParams {
    if (typeof value === 'object' && value instanceof Date === false) {
      httpParams = this.addToHttpParamsRecursive(httpParams, value);
    } else {
      httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
    }
    return httpParams;
  }

  private addToHttpParamsRecursive(httpParams: HttpParams, value?: any, key?: string): HttpParams {
    if (value == null) {
      return httpParams;
    }

    if (typeof value === 'object') {
      if (Array.isArray(value)) {
        (value as any[]).forEach(elem => (httpParams = this.addToHttpParamsRecursive(httpParams, elem, key)));
      } else if (value instanceof Date) {
        if (key != null) {
          httpParams = httpParams.append(key, (value as Date).toISOString().substring(0, 10));
        } else {
          throw Error('key may not be null if value is Date');
        }
      } else {
        Object.keys(value).forEach(
          k => (httpParams = this.addToHttpParamsRecursive(httpParams, value[k], key != null ? `${key}.${k}` : k))
        );
      }
    } else if (key != null) {
      httpParams = httpParams.append(key, value);
    } else {
      throw Error('key may not be null if value is not object or array');
    }
    return httpParams;
  }
}
